export { default } from "./NoticeDetail";

